import { BellOutlined } from '@ant-design/icons';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Badge, ConfigProvider, notification, Popover } from 'antd';
import NotificationDetail from 'components/pages/Notification/components/NotificationDetail';
import TcButton from 'components/UI/button/TcButton';
import Notifications from 'components/UI/layout/components/headerNotification/Notifications';
import { SIGNAL_URL } from 'global/utils/ApiService';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getMyNotifications } from 'redux/reducer/notification/getMyNotifications';
import { setMyNotifications } from 'redux/reducer/notification/notificationReducer';
import { store } from 'redux/store';

const HeaderNotification: FC = () => {
  //state
  const userProfile = useSelector((state: any) => state.user.userProfile);
  const { myNotifications } = useSelector((state: any) => state.notification);
  const [connection, setConnection] = useState<HubConnection | null>(null);
  const [showNotificationDetail, setShowNotificationDetail] = useState();

  //hooks
  const history = useHistory();

  //effect
  useEffect(() => {
    store.dispatch(setMyNotifications(null));
    userProfile?.id && myNotifications === null && store.dispatch(getMyNotifications(userProfile?.id));
  }, [userProfile]);

  useEffect(() => {
    if (!userProfile.id) return;
    const token = localStorage.getItem('sessionid');
    if (!token) return;
    const newConnection = new HubConnectionBuilder()
      .withUrl(SIGNAL_URL + 'TicketHub?userid=' + userProfile?.id, {
        headers: {
          authorization: token,
        },
        withCredentials: true,
      })
      .build();
    setConnection(newConnection);
  }, [userProfile?.id]);

  useEffect(() => {
    if (!connection) return;
    connection
      .start()
      .then(() => {
        connection.on('SendNotification', (res) => {
          openNotification(res.data);
          store.dispatch(getMyNotifications(userProfile?.id));
        });
      })
      .catch(() => {});
  }, [connection]);

  //function
  const openNotification = (data: any) => {
    const showOsNotif = localStorage.getItem('showNotifications');

    if (showOsNotif == 'show') {
      const windowNotif = new Notification(data.title, { body: data.description });
      windowNotif.onclick = function () {
        window.parent.focus();
        windowNotif.close();
      };
    }
    notification.info({
      message: data.title,
      description: data.description,
      duration: 0,
      key: data.id,
      btn: (
        <TcButton
          type='primary'
          size='small'
          onClick={() => {
            history.push(data.frontendRoute.url + data.contextId);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            notification.close(data.id);
          }}>
          نمایش {data.frontendRoute.title}
        </TcButton>
      ),
      onClick: () => {},
    });
  };

  const closeNotification = useCallback(() => {
    setShowNotificationDetail(undefined);
  }, []);

  const unseenCount = useMemo(() => {
    if (!myNotifications) return 0;
    return myNotifications.data.filter((notif: any) => !notif.seen).length;
  }, [myNotifications]);

  return (
    <>
      <ConfigProvider direction='ltr'>
        <Badge count={unseenCount} className='badge-rtl-fix'>
          <Popover
            placement='bottom'
            autoAdjustOverflow
            content={<Notifications showNotificationDetail={setShowNotificationDetail} />}
            title={
              <div className='flex items-center justify-between'>
                <p className='mb-0'>اعلان ها</p>
              </div>
            }
            overlayInnerStyle={{
              boxShadow: '0px 3px 6px rgba(0,0,0,0.2)',
              zIndex: 10,
              backgroundColor: 'var(--bg-color)',
            }}>
            <div className='flex items-center justify-center p-2 text-sm text-center transition-all duration-500 border rounded-md cursor-pointer hover:bg-t-layer-bg-color border-t-border-color-base'>
              <BellOutlined className='mx-1' />
            </div>
          </Popover>
        </Badge>
      </ConfigProvider>

      <NotificationDetail close={closeNotification} detail={showNotificationDetail} userId={userProfile?.id} handleSeen />
    </>
  );
};

export default HeaderNotification;
